import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DeleteConfirmModal = ({ onClose, onConfirm, planName }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-xl max-w-md w-full p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
            <Icon name="AlertTriangle" size={24} className="text-destructive" />
          </div>
          <h2 className="text-xl font-bold text-foreground">Delete Workout Plan</h2>
        </div>

        <p className="text-muted-foreground mb-6">
          Are you sure you want to delete <span className="font-semibold text-foreground">{planName}</span>?
          This action cannot be undone.
        </p>

        <div className="flex gap-3">
          <Button variant="destructive" onClick={onConfirm} fullWidth>
            <Icon name="Trash2" size={18} className="mr-2" />
            Delete
          </Button>
          <Button variant="outline" onClick={onClose} fullWidth>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;